import React from 'react';
import pure from 'recompose/pure';
import SvgIcon from './svg/SvgIcon';

const iconStyle = {
  // width: 22,
  // height: 22,
};

const Close = ({ color, style, ...props }) => (
  /* eslint-disable max-len */
  <SvgIcon {...props} viewBox="0 0 32 32" style={{ ...style, ...iconStyle }}>
    <path
      fill={color || '#C4C8CE'}
      d="M10.722 9.97l-.754.753L15.246 16l-5.253 5.254.754.754L16 16.755l5.253 5.253.754-.754L16.754 16l5.278-5.277-.754-.754L16 15.246z"
    />
    />
  </SvgIcon>
  /* eslint-enable max-len */
);

export default pure(Close);
